module.exports = __webpack_public_path__ + "img/activities-choir.30febb47.jpg";